import React, { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const EMPTY = { en: "", base_price: "" };

export default function CustomPanelForm({ onAdd }) {
  const [form, setForm] = useState(EMPTY);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = () => {
    if (!form.en.trim() || form.base_price === "") {
      toast.error("Enter a panel name and price");
      return;
    }
    onAdd({ en: form.en.trim(), base_price: form.base_price });
    toast.success("Panel added", { description: form.en });
    setForm(EMPTY);
  };

  return (
    <div className="rounded-xl border border-dashed border-slate-700 bg-slate-950/30 p-3 mt-3">
      <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-2 flex items-center gap-1.5"><Plus className="w-3.5 h-3.5" /> Custom panel · 自定义</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input placeholder="Panel / item name (e.g. Spoiler, Grille)" value={form.en} onChange={set("en")} data-testid="custom-panel-name-input" className="bg-slate-950/60 border-slate-700 h-9 text-sm" />
        <Input placeholder="Price" type="number" value={form.base_price} onChange={set("base_price")} data-testid="custom-panel-price-input" className="bg-slate-950/60 border-slate-700 h-9 text-sm font-mono-num sm:w-24" />
        <Button onClick={submit} data-testid="custom-panel-add-btn" className="bg-amber-500 hover:bg-amber-400 text-slate-950 h-9 font-bold shrink-0"><Plus className="w-4 h-4" /></Button>
      </div>
    </div>
  );
}
